import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import { suspend } from 'suspend-react'
import * as THREE from 'three'

import AsyncBoundary from '@components/AsyncBoundary.tsx'
import ubicaIcon from '@components/navbar/ubica.webp?no-inline'
import { useRegisterForAnimation } from '@components/storeMap/floor/3d/AnimationContext'
import { loadTexture } from '@components/storeMap/floor/3d/util'

const padding = 0.2

interface SpinningCubeProps {
  size?: number
  y?: number
  bobbing?: boolean
}

function SpinningUbicaCube({ size = 5, y = 4, bobbing = true }: SpinningCubeProps) {
  const meshRef = useRef<THREE.Mesh>(null)

  useRegisterForAnimation()

  const textureSize = size * 50
  const texture = suspend(() =>
    loadTexture({
      imageUrl: ubicaIcon,
      size: textureSize,
      canvasMutationCallback: (img, ctx) => {
        const logoSize = textureSize * (1 - padding * 2)
        const offset = textureSize * padding

        ctx.fillStyle = '#BDCAD6'
        ctx.fillRect(0, 0, textureSize, textureSize)

        // Draw the image centered with padding
        ctx.drawImage(img, offset, offset, logoSize, logoSize)
      },
    }),
  [ubicaIcon, size])

  useFrame((state, delta) => {
    if (!meshRef.current) return

    meshRef.current.rotation.x += delta * 0.5
    meshRef.current.rotation.y += delta * 0.7
    if (bobbing) {
      meshRef.current.position.y = y + Math.sin(state.clock.elapsedTime * 2) * 0.3
    }
  })

  return (
    <mesh ref={meshRef} position={[0, y, 0]} castShadow>
      <boxGeometry args={[size, size, size]} />
      <meshStandardMaterial map={texture} side={THREE.DoubleSide} />
    </mesh>
  )
}

function WrappedSpinningUbicaCube(props: SpinningCubeProps) {
  return (
    <AsyncBoundary>
      <SpinningUbicaCube {...props} />
    </AsyncBoundary>
  )
}

export default WrappedSpinningUbicaCube